import DiscirdIcon from "../assets/images/dicIcn.png";
import Xicon from "../assets/images/xIcon.png";
import MediumIcon from "../assets/images/Medium-Icon-Black.svg";
import Logo from "../assets/images/logo.svg";

const Footer = () => {
    return (
        <footer className="px-[31px] bg-black">
          <div className="flex text-white w-full max-w-[1180px] mx-auto">
            {/* Left Side - Logo and Description */}
            <div className="w-1/2 pr-8">
              <img src={Logo} alt="Solera" className="w-[120px] mb-6" />
              <p className="text-[10px] leading-[171%] text-gray-400 font-sans max-w-[400px]">
                Solera.market provides information and resources about the fundamentals of the decentralised non-custodial liquidity protocol called the Solera Protocol, comprised of open-source self-executing smart contracts that are deployed on various permissionless public blockchains. 
              </p>
            </div>

            {/* Right Side - Navigation Links */}
            <div className="w-1/2">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8 md:mt-0">
                {/* Social Section */}
                <div>
                  <h3 className="font-sora text-[14px] font-semibold leading-[171%] tracking-[-0.28px]">Social</h3>
                  <ul className="mt-2 space-y-1 text-gray-400">
                    <li>
                      <a href="https://discord.gg/jAdmVMEhJr" target="_blank" rel="noopener noreferrer" className="flex gap-2 hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">
                        <img src={DiscirdIcon} alt="Discord" className="w-4 h-4"/>
                        Discord
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/SoleraLabs" target="_blank" rel="noopener noreferrer" className="flex gap-2 hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">
                        <img src={Xicon} alt="Twitter" className="w-4 h-4"/>
                        Twitter
                      </a>
                    </li>
                    <li>
                      <a href="https://medium.com/@SoleraMarkets" className="flex gap-2 hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">
                        <img src={MediumIcon} alt="Email" className="w-4 h-4"/>
                        Medium
                      </a>
                    </li>
                  </ul>
                </div>
    
                {/* App Section */}
                <div>
                  <h3 className="font-sora text-[14px] font-semibold leading-[171%] tracking-[-0.28px]">App</h3>
                  <ul className="mt-2 space-y-1 text-gray-400">
                    <li><a href="https://app.solera.market" target="_blank" rel="noopener noreferrer" className="hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">Market</a></li>
                    
                  </ul>
                </div>
    
                {/* Company Section */}
                <div>
                  <h3 className="font-sora text-[14px] font-semibold leading-[171%] tracking-[-0.28px]">Company</h3>
                  <ul className="mt-2 space-y-1 text-gray-400">
                    <li><a href="mailto:chef@solerasavings.com" className="hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">Careers</a></li>
                    <li><a href="https://medium.com/@SoleraMarkets" target="_blank" rel="noopener noreferrer" className="hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">Blog</a></li>
                    <li><a href="http://drive.google.com/drive/folders/19FsajlHCZZvHH0h0xM_VEpSOhd-Ns22O" className="hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">Brand assets</a></li>
                    <li><a href="https://docs.solera.market/" target="_blank" rel="noopener noreferrer" className="hover:text-white font-sans text-[14px] font-medium leading-[171%] tracking-[-0.28px]">Docs</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
    
          {/* Bottom Line */}
          <div className="text-[14px] leading-[120%] text-[#FFF] font-DM Sans mt-[84px] lg:mt-[142px] w-full max-w-[1180px] mx-auto pb-6">
            © 2025 Solera. All rights reserved.
          </div>
        </footer>
      );
}

export default Footer;